import { Component } from '@angular/core';

@Component({
    selector: 'app-help-desk',
    templateUrl: './help-desk.component.html',
    styleUrls: ['./help-desk.component.scss'],
    standalone: false
})
export class HelpDeskComponent {

}
